import { useState, memo, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import Num2persian from "num2persian";
import { toast } from "react-toastify";

import { getCredit, paymentWithTransactionId } from "../../Actions/Actions";
import { persianArabicToEnglish } from "../../Utils/UnicodeConvert";
import SpinnerButton from "../../Components/SpinnerButton";
import WalletSwitch from "../../Components/WalletSwitch";
import { priceDigitSeperator } from "../../Utils/Helpers";
import ModalResult from "../../Components/ModalResult";
import tickIcon from "../../Assets/Images/tick.svg";
import Business from "../../Components/Business";
import Loading from "../../Components/Loading";
import Amount from "../../Components/Amount";
import Logo from "../../Components/Logo";
import "./styles.css";

const Screen = (props) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [modalResult, setModalResult] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({});
  const [credit, setCredit] = useState("");
  const [result, setResult] = useState({});
  const history = useHistory();

  useEffect(() => {
    const data = props.location.state.result;
    setDetail(data);
    // getCredit().then(res => {
    //     setCredit(res);
    // }).catch(err => {
    //     if (err.status === 401) {
    //         history.push({
    //             pathname: "/sign-in",
    //             state: props?.location?.state?.transactionId
    //         });
    //     };
    // });
  }, []);

  const onClickPayment = () => {
      setBtnLoading(true);
      const params = {
        transaction_id: props?.location?.state?.transactionId,
        club_id: 1,
        amount: detail?.total_amount,
        payment_using_wallet_balance: true,
        ewallets: selectedOptions,
      };
      paymentWithTransactionId(params)
        .then((data) => {
          history.push({
            pathname: "/result",
            state: {
              transactionId: props?.location?.state?.transactionId,
            },
          });
        })
        .catch((err) => {
          setResult(err);
          setModalResult(true);
        })
        .finally((_) => {
          setBtnLoading(false);
        });
  };

  return (
    <div className="payment">
      {!loading ? (
        <Fragment>
          <Logo />
          <Business data={detail} />
          <div className="sign-in-form">
            <p className="sign-in-form-p">مبلغ قابل پرداخت</p>
            <div className="payment-section-form-amount position-relative">
              <div className="payment-section-form-amount-input">
                {priceDigitSeperator(detail?.total_amount)}
              </div>
              <p className="position-absolute">تومان</p>
            </div>
            <small className="text-left mt-1">
              {Num2persian(
                Math.floor(persianArabicToEnglish(detail?.total_amount)) * 10,
              )}{" "}
              ریال
            </small>
            <div className="payment-section-form-credit mb-2">
              <img className="tickIcon" src={tickIcon} />
              <span className="payment-section-form-credit_text">
                موجودی کیف پول شما:{" "}
                <span className="payment-form-credit_blue">
                  {priceDigitSeperator(credit) || "0"} تومان
                </span>
              </span>
            </div>
            <WalletSwitch
              businessId={props?.location?.state?.result?.business_id}
              // businessId={"3609"}
              subCategoryId={props?.location?.state?.result?.sub_category_id}
              selectedPaymentOptions={(options) => {
                setSelectedOptions(options);
                // console.log("options", options)
              }}
              credit={(value) => setCredit(value)}
            />
            <Amount
              amount_of_transaction={detail?.total_amount}
              eWallets={selectedOptions}
            />
            <SpinnerButton
              className="sign-in-form-btn px-5 py-4"
              onClick={onClickPayment}
              text="پرداخت"
              loading={btnLoading}
            />
          </div>
        </Fragment>
      ) : (
        <Loading />
      )}
      <ModalResult
        show={modalResult}
        onClose={() => setModalResult(false)}
        result={result}
      />
    </div>
  );
};
export default memo(Screen);
